export default {
      id: "battery-lvl-50-usage",
      viewBox: "0 0 22 14",
      url: __webpack_public_path__ + "img/icons.svg#battery-lvl-50",
      toString: function () {
        return this.url;
      }
    }